import type { TileCatalogBrowserSection } from "./TileCatalogBrowser";

/**
 * Survives TilePicker unmount when the modal closes so reopening restores folder depth
 * (and generator view) instead of resetting to the catalog root.
 */
export const tilePickerNavigationMemory = {
  sectionPath: [] as TileCatalogBrowserSection[],
  generatorSection: null as TileCatalogBrowserSection | null,
};

export function cloneSectionPath(path: TileCatalogBrowserSection[]): TileCatalogBrowserSection[] {
  return path.map((s) => ({ ...s, tileSetIds: [...s.tileSetIds] }));
}

function cloneGeneratorSection(section: TileCatalogBrowserSection): TileCatalogBrowserSection {
  return { ...section, tileSetIds: [...section.tileSetIds] };
}

export function readInitialSectionPathFromMemory(): TileCatalogBrowserSection[] {
  return cloneSectionPath(tilePickerNavigationMemory.sectionPath);
}

export function readInitialGeneratorSectionFromMemory(): TileCatalogBrowserSection | null {
  const s = tilePickerNavigationMemory.generatorSection;
  return s ? cloneGeneratorSection(s) : null;
}

export function commitSectionPathToMemory(path: TileCatalogBrowserSection[]) {
  tilePickerNavigationMemory.sectionPath = cloneSectionPath(path);
}

export function commitGeneratorSectionToMemory(section: TileCatalogBrowserSection | null) {
  tilePickerNavigationMemory.generatorSection = section ? cloneGeneratorSection(section) : null;
}

/** @internal */
export function resetTilePickerNavigationMemoryForTests() {
  tilePickerNavigationMemory.sectionPath = [];
  tilePickerNavigationMemory.generatorSection = null;
}
